<div class="inner-container">
  <div class="terms-use">
    <h1  translate>label_privacy_policy</h1>
    <div class="" >
      <p>{{privacyPolicyData}}</p>
    </div>
  </div>
</div>